const $inject = ['$scope','$routeParams', 'dataService', 'settingsService'];

const lbaMultiSelectGroupCtrl = function ($scope, $routeParams, dataService, settingsService) {
  const vm = this;

  const parentDataLookUp = dataService.spiltDataAt(vm.settings.parent.dataAt, $routeParams);
  const childDataLookUp = dataService.spiltDataAt(vm.settings.child.dataAt, $routeParams);

  vm.parent = {};
  vm.parent.data = _.get(dataService.data.activeItem, parentDataLookUp);
  vm.parent.items = settingsService.options[vm.settings.parent.optionsAt];

  $scope.$watchCollection('vm.parent.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, parentDataLookUp, newData)
      vm.child.items =  [...newData];
      vm.child.data = vm.child.data.filter(i => newData.includes(i));
    }
  });

  vm.child = {};
  const childData = _.get(dataService.data.activeItem, childDataLookUp) || [];
  vm.child.data = childData.filter(i => vm.parent.data.includes(i));
  vm.child.items = vm.parent.data

  $scope.$watchCollection('vm.child.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, childDataLookUp, newData)
    }
  });
};

lbaMultiSelectGroupCtrl.$inject = $inject;

export default lbaMultiSelectGroupCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaMultiSelectGroup/lbaMultiSelectGroupCtrl.js